import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { FAQ } from '../components/FAQ';
import { HowItWorks } from '../components/HowItWorks';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
import { JsonLd, useSEO } from '../utils/seo';
import { localBusinessSchema } from '../utils/localBusiness';
export function Home() {
  useSEO({
    title: 'Gravel Delivery Seattle, WA | Same-Day Bulk Materials | 206Gravel',
    description: 'Order gravel, crushed rock, topsoil, bark, and drain rock online with dependable same-day and next-day delivery across Seattle, King County, and Pierce County.',
    path: '/'
  });
  return <main data-id="element-3548" data-mp="3kuiijhaa4o7w">
      <JsonLd data={localBusinessSchema()} data-id="element-3549" data-mp="3kv0nd2b0carf" />
      <div className="dark" data-id="element-3550" data-mp="3owlwcckf84wc">
        <Hero data-id="element-3551" data-mp="3ovud8180fzmy" />
      </div>
      {/* The materials catalog sits directly under the hero. It used to run
          fourth, behind WhyUs and ByTheNumbers, which meant a customer who
          didn't already know their material had to scroll past two trust
          sections before seeing a single product photo. Browsing is the second
          thing the page offers now; the trust sections follow it. */}
      <Services data-id="element-3552" data-mp="2mw8j1evbp1g0" />
      <WhyUs data-id="element-3553" data-mp="2mwqq76jix02p" />
      <ByTheNumbers data-id="element-3554" data-mp="2mz37rildd8f8" />
      <FAQ data-id="element-3555" data-mp="2hxnj7gjzgjs3" />
      {/* Ordering process sits directly above the testimonials: answer the
          "how does this work?" question, then back it with social proof. */}
      <HowItWorks data-id="element-3556" data-mp="2d5vyvnrf7aae" />
      <Reviews data-id="element-3557" data-mp="2883z67kjajvn" />
      <CtaBanner data-id="element-3558" data-mp="287ugz65qdh0i" />
    </main>;
}